import React, { useLayoutEffect, useRef, useState } from "react";
import InputField from "./InputField";
import showPasswordIcon from "../../assets/ShowPasswordIcon.svg";
import hidePasswordIcon from "../../assets/hidePassword.svg";
import "./PasswordFieldWithEye.css";

// Adds a show/hide eye toggle on top of the existing InputField, without modifying InputField
// itself -- the icon's vertical position is measured off the REAL rendered <input> (located via
// InputField's own data-testid={`field-${name}`}) rather than a guessed pixel offset, since
// InputField renders a label above the input and different screens' labels/spacing can't be
// assumed to share one fixed height.
interface PasswordFieldWithEyeProps {
  name: string;
  label: string;
  placeholder: string;
  requiredMessage: string;
  required?: boolean;
  allowSpecialChars?: boolean;
  disabled?: boolean;
  validation?: React.ComponentProps<typeof InputField>["validation"];
}

const PasswordFieldWithEye: React.FC<PasswordFieldWithEyeProps> = ({
  name,
  label,
  placeholder,
  requiredMessage,
  required = true,
  allowSpecialChars = true,
  disabled,
  validation,
}) => {
  const [show, setShow] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [eyeTop, setEyeTop] = useState<number | null>(null);

  useLayoutEffect(() => {
    const input = wrapperRef.current?.querySelector<HTMLInputElement>(
      `[data-testid="field-${name}"]`
    );
    if (input) {
      setEyeTop(input.offsetTop + input.offsetHeight / 2);
    }
  }, [name]);

  return (
    <div className="password-field-with-eye-wrapper" ref={wrapperRef}>
      <InputField
        name={name}
        label={label}
        placeholder={placeholder}
        type={show ? "text" : "password"}
        required={required}
        requiredMessage={requiredMessage}
        allowSpecialChars={allowSpecialChars}
        disabled={disabled}
        validation={validation}
      />
      {eyeTop !== null && (
        <span
          className="password-field-with-eye-icon"
          onClick={() => setShow((prev) => !prev)}
          style={{
            top: eyeTop,
            backgroundImage: `url(${show ? hidePasswordIcon : showPasswordIcon})`,
          }}
        />
      )}
    </div>
  );
};

export default PasswordFieldWithEye;
